<template>
  <div>
    <div class="row">
      <div class="col-sm-12 graph-box">
        <OnChangementsEtatDesPlans height=100 width=300 :data=data.changements></OnChangementsEtatDesPlans>
      </div>

    </div>
  </div>
</template>

<script>
import OnChangementsEtatDesPlans from '@/components/OnChangementsEtatDesPlans.vue';
import axios from 'axios';

export default {
  data: function() {return {
    data: {
      changements:[]
    }
  }},

  name: 'Plans',
  components: {
    OnChangementsEtatDesPlans
  },
  methods: {
    enterClicked: function() {
      this.refresh()
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/semaines.php',
          { })
        .then(response => (this.data.changements = response.data))
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style>
</style>
